"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distinctSlugContext = void 0;
// ---- UI-graph slug context --------------------------------------------------
// Derive the distinct { id, slug } CF/LP context from a UI graph's own node
// configs, treating the slug as the id. This is what structural validation
// (`tapeBuilderGraphToArtifactsDocument`) needs when it only has to confirm the
// referenced facilities/products are *resolvable within the graph* — not that
// they match real DB ids or belong to the org (that is enforced separately at
// commit via `checkReferencedEntities`).
//
// Node `configuration` is opaque (`{}`) at this layer, so the slug fields are
// read via a single localized structural view. Passing empty sets instead would
// spuriously reject every graph that names a facility.
//
// Shared by the AgentV `validate_graph` tool and the `graph`/`bus seed` CLIs.
const distinctSlugContext = (graph, key) => {
    const slugs = graph.nodes
        .map((node) => node.configuration[key])
        .filter((slug) => typeof slug === 'string' && slug.length > 0);
    return Array.from(new Set(slugs)).map((slug) => ({ id: slug, slug }));
};
exports.distinctSlugContext = distinctSlugContext;
//# sourceMappingURL=slugContext.js.map